/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-12-08 11:01:00
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:57:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/TopLeaderBoardBanner/index.tsx
 */
import LinkImage from '@/src/constrains/LinkImg';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { LinkModuleType } from '@/src/types/common/linkType';
import React from 'react';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSubmitStamp,
  getTopLeaderBoardBanner,
  onCollapseOpen,
  onErrorChange,
  onTopLeaderBoardBannerChange,
} from '../slice';
import { topLeaderBoardBannerValidation } from '../tools';
import css from './css.module.less';

// import {
//   //EPreviewSize,
//   WebSiteSubType,
// } from '@/src/types/common/SalesChannel';
function TopLeaderBoardBanner(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const _d = useDispatch();
  const {
    data,
    specificError,
    salesChannelContentUuid,
    // currentSize,
    //currentStyle,
  } = props;
  const { linkImageError = [], linkTypeError = [] } = specificError;
  const { link } = data || {};
  const { linkType, uuid, label, action, linkImage } = link || {};
  // const showImageDisplaySetting =
  //   currentStyle === WebSiteSubType.ResponsivePage;
  // &&
  // (currentSize === EPreviewSize.TABLET ||
  //   currentSize === EPreviewSize.MOBILE);
  const handleOnLinkChange = (link) => {
    _d(onTopLeaderBoardBannerChange(link));
  };
  const handleOnLinkImageChange = (linkImage) => {
    _d(onTopLeaderBoardBannerChange({ linkImage }));
  };

  return (
    <Section className={css.linkImageContainer}>
      <LinkImage
        imageErrorArray={linkImageError}
        linkTypeErrorArray={linkTypeError}
        linkSet={{
          scopeVariables: { SalesChannelContent: salesChannelContentUuid },
          linkTypeFilter: [
            LinkModuleType.Product,
            LinkModuleType.Collection,
            LinkModuleType.ContentPage,
            LinkModuleType.LinkLibrary,
            LinkModuleType.None,
            LinkModuleType.SysModule,
          ],
        }}
        linkImage={linkImage}
        link={{ linkType, uuid, label, action }}
        title={getI18n('general.checkImgDraggableDisplay.title')}
        linkId={`link`}
        subtitle={`${getI18n(
          'general.allowedfiletypes',
        )}: jpeg, gif, png, mov, mp4`}
        linkOnChange={handleOnLinkChange}
        imgOnChange={handleOnLinkImageChange}
        // showImageDisplaySetting={showImageDisplaySetting}
      />
    </Section>
  );
}

export default ErrorProcessingHOC(TopLeaderBoardBanner, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.topLeaderBoardBanner,
  getContent: getTopLeaderBoardBanner,
  title: getI18nFromGeneral('general.hOCTitle.topLeaderBoardBanner'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: topLeaderBoardBannerValidation,
  getSubmitStamp,
});
